module.exports = __webpack_public_path__ + "assets/images/signup-provider.2179b0cd0e37e9262680423c57174969.svg";